import { PageHeader, LoadingState, DataTable } from '../components/AdminPageUI';
import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, Button, TextField, Grid, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Switch, Autocomplete } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import api from '../utils/Api';
import { toast } from 'react-toastify';

export default function PayrollSettingsPage() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [form, setForm] = useState({ name: '', type: 'earning', amount: 0, isDefault: false });

  useEffect(() => { fetchSettings(); }, []);

  const fetchSettings = async () => {
    try {
      const res = await api.get('/payroll/settings');
      setSettings(res.data.settings);
    } catch (err) {
      toast.error('Failed to load payroll settings');
    } finally { setLoading(false); }
  };

  const handleSaveComponent = async () => {
    try {
      const updatedComponents = [...(settings?.components || []), { ...form, active: true }];
      await api.post('/payroll/settings', { ...settings, components: updatedComponents });
      toast.success('Component added');
      setOpenDialog(false);
      fetchSettings();
    } catch (err) {
      toast.error('Failed to save component');
    }
  };

  const handleDeleteComponent = async (index) => {
    try {
      const updatedComponents = [...settings.components];
      updatedComponents.splice(index, 1);
      await api.post('/payroll/settings', { ...settings, components: updatedComponents });
      toast.success('Component removed');
      fetchSettings();
    } catch (err) {
      toast.error('Failed to remove component');
    }
  };

  const handleSavePenalties = async () => {
    try {
      await api.post('/payroll/settings', { ...settings, attendancePenalties: settings.attendancePenalties });
      toast.success('Penalties updated');
    } catch (err) {
      toast.error('Failed to update penalties');
    }
  };

  if (loading) return <LoadingState />;

  return (
    <Box p={3}>
      <PageHeader title="Payroll Settings" description="Configure salary components and attendance deductions." actions={<Button variant="contained" startIcon={<Add />} onClick={() => setOpenDialog(true)}>Add Component</Button>} />
      
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}  >
          <Card>
            <CardContent>
              <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="h6">Salary Components (Earnings & Deductions)</Typography>
                
              </Box>
              <DataTable><Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Default Amount</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {settings?.components?.map((c, i) => (
                    <TableRow key={i}>
                      <TableCell>{c.name}</TableCell>
                      <TableCell>{c.type}</TableCell>
                      <TableCell>{c.amount}</TableCell>
                      <TableCell>
                        <IconButton color="error" onClick={() => handleDeleteComponent(i)}><Delete /></IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table></DataTable>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Add Custom Component</DialogTitle>
        <DialogContent>
          <Autocomplete
            freeSolo
            options={['Basic Salary', 'Transport Allowance', 'Housing Allowance', 'Feeding Allowance', 'Bonus', 'Extra Classes', 'Responsibility Allowance']}
            value={form.name}
            onChange={(event, newValue) => setForm({...form, name: newValue || ''})}
            onInputChange={(event, newInputValue) => setForm({...form, name: newInputValue || ''})}
            renderInput={(params) => <TextField {...params} label="Component Name (Select or type custom)" fullWidth margin="normal" />}
          />
          <Select fullWidth margin="normal" value={form.type} onChange={(e) => setForm({...form, type: e.target.value})}>
            <MenuItem value="earning">Earning</MenuItem>
            <MenuItem value="deduction">Deduction</MenuItem>
          </Select>
          <TextField label="Default Amount" type="number" fullWidth margin="normal" value={form.amount} onChange={(e) => setForm({...form, amount: Number(e.target.value)})} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveComponent}>Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
